import { Dialog } from "primereact/dialog";
import React, { useEffect, useRef, useState } from "react";
import Langs from "../../app/lang/langs";
import { InputText } from "primereact/inputtext";
import { AddressAutocomplete } from "../../components/inputs/AddressAutocomplete";
import { Col, Row } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import ImageButton from "../../components/buttons/ImageButton";
import downloadIcon from './../../assets/images/downloadIcon.png'
import downloadIconFocus from './../../assets/images/downloadIconFocus.png'
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import { DataView } from "primereact/dataview";
import { useDispatch, useSelector } from "react-redux";
import { deleteAsset, downloadAsset, getSubcontractorAssets, uploadAsset } from "../../assets/assetsSlice";
import { editSubcontractor, getSubcontractors } from "../../components/clients/clientsSlice";
import { confirmDialog } from "../../components/popups/ConfirmDialog";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";


export default function SubcontractorDetailsModal(props) {

    const dispatch = useDispatch()

    let visible = props.visible
    let subcontractor = props.subcontractor
    const providerTypes = useSelector((state) => state.clients.providerTypes)

    const [subcontractorData, setSubcontractorData] = useState(
        {
            id: null,
            name: null,
            status: null,
            type: null,
            address: null,
            reminders_dates: null,
            reminders_comments: null,
            email: null,
            vfact: null,
            date_attestation_urssaf: null,
            date_fin_attestation_urssaf: null,
            date_attestation_fiscale: null,
            date_fin_attestation_fiscale: null,
            date_fin_validite_rc: null,
            date_attestation_salarie_etranger: null,
            date_fin_attestation_salarie_etranger: null,
            assets: [],
        }
    );
    const statusOptions = [
        { name: 'Actif' },
        { name: 'Inactif' },
    ]
    const typeOptions = providerTypes.map(type => {
        return {
            name: type.value
        }
    })
    const [status, setStatus] = useState(null)
    const [type, setType] = useState(null)

    useEffect(() => {
        setStatus({ name: subcontractorData.status })
    }, [subcontractorData.status])

    useEffect(() => {
        setType({ name: subcontractorData.type })
    }, [subcontractorData.type])

    const handleStatusChange = (e) => {
        const newStatus = e.value;
        setStatus(newStatus);
        setSubcontractorData(prevData => ({
            ...prevData,
            status: newStatus?.name
        }))
    }

    const handleTypeChange = (e) => {
        const newType = e.value;
        setType(newType);
        setSubcontractorData(prevData => ({
            ...prevData,
            type: newType?.name
        }));
    }

    useEffect(() => {
        if (subcontractor) {
            setSubcontractorData({
                ...subcontractor,
                date_attestation_urssaf: subcontractor.date_attestation_urssaf ? moment(subcontractor.date_attestation_urssaf).toDate() : null,
                date_fin_attestation_urssaf: subcontractor.date_fin_attestation_urssaf ? moment(subcontractor.date_fin_attestation_urssaf).toDate() : null,
                date_attestation_fiscale: subcontractor.date_attestation_fiscale ? moment(subcontractor.date_attestation_fiscale).toDate() : null,
                date_fin_attestation_fiscale: subcontractor.date_fin_attestation_fiscale ? moment(subcontractor.date_fin_attestation_fiscale).toDate() : null,
                date_fin_validite_rc: subcontractor.date_fin_validite_rc ? moment(subcontractor.date_fin_validite_rc).toDate() : null,
                date_attestation_salarie_etranger: subcontractor.date_attestation_salarie_etranger ? moment(subcontractor.date_attestation_salarie_etranger).toDate() : null,
                date_fin_attestation_salarie_etranger: subcontractor.date_fin_attestation_salarie_etranger ? moment(subcontractor.date_fin_attestation_salarie_etranger).toDate() : null
            });
        } else {
            setSubcontractorData({
                id: null,
                name: null,
                status: null,
                type: null,
                address: null,
                reminders_dates: null,
                reminders_comments: null,
                email: null,
                vfact: null,
                date_attestation_urssaf: null,
                date_fin_attestation_urssaf: null,
                date_attestation_fiscale: null,
                date_fin_attestation_fiscale: null,
                date_fin_validite_rc: null,
                date_attestation_salarie_etranger: null,
                date_fin_attestation_salarie_etranger: null,
                assets: [],
            })
        }
    }, [subcontractor])

    const onHide = () => {
        props.setVisible(false);
        props.setSubcontractor(null);
        setSubcontractorData(
            {
                id: null,
                name: null,
                status: null,
                type: null,
                address: null,
                reminders_dates: null,
                reminders_comments: null,
                email: null,
                vfact: null,
                date_attestation_urssaf: null,
                date_fin_attestation_urssaf: null,
                date_attestation_fiscale: null,
                date_fin_attestation_fiscale: null,
                date_fin_validite_rc: null,
                date_attestation_salarie_etranger: null,
                date_fin_attestation_salarie_etranger: null,
                assets: [],
            }
        )
    }

    const header = () => {
        let name = subcontractor?.name;
        return (
            <div className="d-flex justify-content-between border-bottom pb-4">
                <h5 className="m-0">{name}</h5>
            </div>
        )
    }

    const closeIcon = () => {
        return (
            <button className="btn btn-sm btn-danger" onClick={onHide}>X</button>
        )
    }

    const getSeverity = (status) => {
        switch (status) {
            case 'Inactif':
                return 'danger';

            case 'Actif':
                return 'success';

            case 'new':
                return 'info';

            case 'negotiation':
                return 'warning';

            case 'renewal':
                return null;
        }
    }

    const statusItemTemplate = (option) => {
        if (!option) return 'Statut...';
        return <Tag style={{ width: "100%" }} value={option?.name} severity={getSeverity(option?.name)} />;
    }

    const assetListTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((asset, index) => {
            return assetTemplate(asset, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    const updateSubcontractor = () => {
        if (subcontractorData && subcontractorData.id && subcontractorData.name.trim() !== '') {
            let toEditSubcontractor = {
                ...subcontractorData,
                date_attestation_urssaf: subcontractorData.date_attestation_urssaf ? moment(subcontractorData.date_attestation_urssaf).format('YYYY-MM-DD') : null,
                //date_fin_attestation_urssaf: subcontractorData.date_fin_attestation_urssaf ? moment(subcontractorData.date_fin_attestation_urssaf).format('YYYY-MM-DD') : null,
                date_attestation_fiscale: subcontractorData.date_attestation_fiscale ? moment(subcontractorData.date_attestation_fiscale).format('YYYY-MM-DD') : null,
                //date_fin_attestation_fiscale: subcontractorData.date_fin_attestation_fiscale ? moment(subcontractorData.date_fin_attestation_fiscale).format('YYYY-MM-DD') : null,
                date_fin_validite_rc: subcontractorData.date_fin_validite_rc ? moment(subcontractorData.date_fin_validite_rc).format('YYYY-MM-DD') : null,
                date_attestation_salarie_etranger: subcontractorData.date_attestation_salarie_etranger ? moment(subcontractorData.date_attestation_salarie_etranger).format('YYYY-MM-DD') : null,
                //date_fin_attestation_salarie_etranger: subcontractorData.date_fin_attestation_salarie_etranger ? moment(subcontractorData.date_fin_attestation_salarie_etranger).format('YYYY-MM-DD') : null,
            };
            dispatch(editSubcontractor({ subcontractor: toEditSubcontractor }))
                .then((response) => {
                    const responseData = response.payload.responseData;
                    if (responseData && responseData.status === 1) {
                        showSuccessToast("Fournisseur modifié avec succès");
                        dispatch(getSubcontractors());
                    }
                })
                .catch((error) => {
                    showErrorToast("An error occurred while updating subcontractor.");
                    console.error("An error occurred while updating subcontractor:", error);
                });
        } else {
            showErrorToast('Veuillez remplir le nom du Fournisseur');
        }
    }

    const assetTemplate = (asset, index) => {
        const downBtn = (asset) => {
            return (
                <ImageButton
                    onClick={() => {
                        dispatch(
                            downloadAsset({
                                tableName: asset.table_name,
                                idParent: asset.id_parent,
                                filename: asset.filename,
                            })
                        )
                    }}
                    image={downloadIcon}
                    imageFocus={downloadIconFocus}
                    active={true}
                    width={22}
                />
            )
        }
        const deleteBtn = (asset) => {
            return (
                <ImageButton
                    onClick={(e) => confirmDelete(e, asset)}
                    image={deleteIcon}
                    imageFocus={deleteIconFocus}
                    active={true}
                    width={22}
                />
            );
        };

        return (
            <Row className='py-2' style={{ borderBottom: "1px #D9D9D9 solid" }}>
                <Col lg={10}>
                    {asset.filename}
                </Col>
                <Col lg={1}>
                    {downBtn(asset)}
                </Col>
                <Col lg={1}>
                    {deleteBtn(asset)}
                </Col>
            </Row>
        )

    }

    const uploadAssetTemplate = (file, idParent, tableName) => {
        if (!file) return;
        const filename = file.name;

        dispatch(uploadAsset({
            file,
            tableName,
            idParent,
            filename
        }))
            .then((actionResponse) => {
                if (uploadAsset.fulfilled.match(actionResponse)) {
                    dispatch(getSubcontractorAssets({ id_subcontractor: subcontractorData.id }))
                        .then((actionResponse) => {
                            if (getSubcontractorAssets.fulfilled.match(actionResponse)) {
                                setSubcontractorData({ ...subcontractorData, assets: actionResponse.payload.responseData.assets })
                                dispatch(getSubcontractors());
                            }
                        })
                }
            })
            .catch((error) => {
                console.error('Error handling in uploadAsset:', error);
            });
    }

    const accept = (event, assetToDelete) => {
        if (assetToDelete) {
            dispatch(
                deleteAsset({
                    tableName: assetToDelete.table_name,
                    idParent: assetToDelete.id_parent,
                    filename: assetToDelete.filename,
                })
            )
                .then((actionResponse) => {
                    if (deleteAsset.fulfilled.match(actionResponse)) {
                        showSuccessToast('Fichier supprimé avec succès');
                        dispatch(getSubcontractorAssets({ id_subcontractor: subcontractorData.id }))
                            .then((actionResponse) => {
                                if (getSubcontractorAssets.fulfilled.match(actionResponse)) {
                                    setSubcontractorData({ ...subcontractorData, assets: actionResponse.payload.responseData.assets })
                                    dispatch(getSubcontractors());
                                }
                            })
                    }
                })
                .catch((error) => {
                    console.error('Error handling in deleteAsset:', error);
                });
        } else {
            return
        }
    }

    const confirmDelete = (event, asset) => {
        confirmDialog({
            title: <Langs str="DELETE_FILE" />,
            message: <Langs str="DELETE_FILE_MSG" />,
            danger: true,
            onConfirm: () => accept(null, asset),
        })
    }

    const body = () => {

        return (
            <div className="row " style={{ height: "calc(100vh - 200px)", overflowY: "auto" }}>
                <Col xl={12} className="d-flex justify-content-between mb-2">
                    <p className="my-auto"><Langs str='Nom' /></p><InputText style={{ width: '25rem' }} placeholder="Nom" value={subcontractorData.name} onChange={(e) => setSubcontractorData({ ...subcontractorData, name: e.target.value })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='STATUS' /></p>
                    <Dropdown value={status} style={{ width: '25rem' }} itemTemplate={statusItemTemplate} valueTemplate={statusItemTemplate} onChange={handleStatusChange} options={statusOptions} optionLabel="name"
                        placeholder="statut..." className="w-full md:w-14rem" />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='TYPE' /></p>
                    <Dropdown value={type} style={{ width: '25rem' }} onChange={handleTypeChange} options={typeOptions} optionLabel="name"
                        placeholder="Type..." className="w-full md:w-14rem" />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='ADDRESS' /></p>
                    <AddressAutocomplete style={{ width: '25rem' }} value={subcontractorData.address} onSelect={(option) => setSubcontractorData({ ...subcontractorData, address: option ? option.label : null })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='EMAIL' /></p>
                    <InputText style={{ width: '25rem' }} placeholder="Email..." value={subcontractorData.email} onChange={(e) => setSubcontractorData({ ...subcontractorData, email: e.target.value })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='REMINDERS_DATES' /></p>
                    <InputTextarea
                        rows={3}
                        cols={30}
                        style={{ width: '25rem' }}
                        value={subcontractorData.reminders_dates}
                        onChange={(e) => setSubcontractorData({ ...subcontractorData, reminders_dates: e.target.value })}
                        autoResize={true}
                        placeholder="Dates..."
                    />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='REMINDERS_COMMENTS' /></p>
                    <InputTextarea
                        rows={3}
                        cols={30}
                        style={{ width: '25rem' }}
                        value={subcontractorData.reminders_comments}
                        onChange={(e) => setSubcontractorData({ ...subcontractorData, reminders_comments: e.target.value })}
                        autoResize={true}
                        placeholder="Comments..."
                    />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='vFact' /></p><InputText style={{ width: '25rem' }} placeholder="vFACT" value={subcontractorData.vfact} onChange={(e) => setSubcontractorData({ ...subcontractorData, vfact: e.target.value })} />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_ATTESTATION_URSSAF' /></p>
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_attestation_urssaf} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_attestation_urssaf: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_FIN_ATTESTATION_URSSAF' /></p>
                    <Calendar disabled dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_fin_attestation_urssaf} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_fin_attestation_urssaf: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_ATTESTATION_FISCALE' /></p>
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_attestation_fiscale} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_attestation_fiscale: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_FIN_ATTESTATION_FISCALE' /></p>
                    <Calendar disabled dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_fin_attestation_fiscale} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_fin_attestation_fiscale: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_FIN_VALIDITE_RC' /></p>
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_fin_validite_rc} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_fin_validite_rc: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_ATTESTATION_SALARIE_ETRANGER' /></p>
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_attestation_salarie_etranger} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_attestation_salarie_etranger: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='DATE_FIN_ATTESTATION_SALARIE_ETRANGER' /></p>
                    <Calendar disabled dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={subcontractorData.date_fin_attestation_salarie_etranger} style={{ width: '25rem' }} onChange={(e) => setSubcontractorData({ ...subcontractorData, date_fin_attestation_salarie_etranger: e.target.value })} showButtonBar />
                </Col>
                <Col xl={12} className="d-flex justify-content-between my-2">
                    <p className="my-auto"><Langs str='Documents' /></p>
                    <div>
                        <DataView
                            value={subcontractorData.assets}
                            listTemplate={assetListTemplate}
                            paginator
                            paginatorPosition="top"
                            rows={5}
                            className="card p-2"
                            style={{ height: "340px", width: "25rem" }}
                        />
                        <input
                            className="form-control"
                            type="file"
                            id="formFile"
                            onChange={(e) => { uploadAssetTemplate(e.target.files[0], subcontractorData.id, 'subcontractors') }} //handleFileUpload(e.target.files[0], 'collabs')}
                            style={{ marginTop: '10px' }}
                        />
                    </div>
                </Col>

            </div>
        )
    }

    const footer = () => {
        return (
            <div className="d-flex justify-content-center border-top pt-4">
                <button className="btn btn-success w-25" onClick={e => { updateSubcontractor() }}><Langs str='SAVE' /></button>
            </div>
        )
    }

    return (
        <div>
            <Dialog
                header={header}
                visible={visible}
                draggable={false}
                position="right"
                style={{ width: '45rem', height: "100vh", maxHeight: "100%", marginRight: 0 }}
                onHide={onHide}
                closeIcon={closeIcon}
                footer={footer}
            >
                {body()}
            </Dialog>
        </div>
    )
}